module.exports = __webpack_public_path__ + "static/media/portrait.f3e8cb03.jpg";